/**
 * Currently this file is manually maintained using data from: https://www.localeplanet.com/icu/
 *
 * Note. Underscores in the langLocale field are replaced as hyphens to be compatible
 * with .NET and browsers.
 */
import { EnumFeatureFlag } from "@/app/services/generated/enums/enumFeatureFlag.generated";

// To add a new language.
// 1. Enter an entry here
// 2. Update __icons.sass with any new country flags referenced
// 3. Update translations spreadsheet to add a column and create a record in the language group to describe that language

export interface LangLocaleDefinition {
  langLocale: string;
  nativeDescription: string;
  countryFlag: string;
  localeResource?: string;
  featureFlag?: EnumFeatureFlag;
}

export const supportedLangLocales: LangLocaleDefinition[] = [
  {
    langLocale: "en",
    nativeDescription: "English (World)",
    localeResource: "en",
    countryFlag: "gb",
  },
  {
    langLocale: "en-GB",
    nativeDescription: "English (United Kingdom)",
    countryFlag: "gb",
  },
  {
    langLocale: "en-DE",
    nativeDescription: "English (Germany)",
    countryFlag: "de",
  },
  {
    langLocale: "de-DE",
    nativeDescription: "Deutsch (Deutschland)",
    localeResource: "de-de",
    countryFlag: "de",
    featureFlag: EnumFeatureFlag.germanLanguageSupport,
  },
  {
    langLocale: "en-ZA",
    nativeDescription: "English (South Africa)",
    countryFlag: "za",
  },
  {
    langLocale: "en-US",
    nativeDescription: "English (United States)",
    localeResource: "en-us",
    countryFlag: "us",
  },
  {
    langLocale: "en-SE",
    nativeDescription: "English (Sweden)",
    countryFlag: "se",
  },
  {
    langLocale: "en-AU",
    nativeDescription: "English (Australia)",
    localeResource: "en-au",
    countryFlag: "au",
  },
  {
    langLocale: "en-NZ",
    nativeDescription: "English (New Zealand)",
    localeResource: "en-nz",
    countryFlag: "nz",
  },
  {
    langLocale: "en-IE",
    nativeDescription: "English (Ireland)",
    localeResource: "en-ie",
    countryFlag: "ie",
  },
  {
    langLocale: "lt-LT",
    nativeDescription: "Lietuvių (Lietuva)",
    localeResource: "lt-lt",
    countryFlag: "lt",
  },
];

/**
 * Given a lang locale string, find the corresponding supported lang locale - or
 * fallback if not able to match it.
 */
export function parseLangLocaleOrFallback(
  desiredLangLocale: string
): LangLocaleDefinition {
  return (
    supportedLangLocales.find(
      (ll) =>
        ll.langLocale.toLowerCase() === desiredLangLocale.trim().toLowerCase()
    ) ?? supportedLangLocales[0]
  );
}
